<template>
  <div>
    <!-- Why Choose Us Section -->
    <div class="elementor-element elementor-element-249ad868 e-flex e-con-boxed e-con e-parent" data-id="249ad868"
      data-element_type="container"
      data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
      data-core-v316-plus="true">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-4dec71d6 elementor-widget elementor-widget-heading"
          data-id="4dec71d6" data-element_type="widget" data-widget_type="heading.default">
          <div class="elementor-widget-container">
            <h2 class="elementor-heading-title elementor-size-default">Why Choose Us:</h2>
          </div>
        </div>
        <div class="elementor-element elementor-element-15a1af15 elementor-widget elementor-widget-text-editor"
          data-id="15a1af15" data-element_type="widget" data-widget_type="text-editor.default">
          <div class="elementor-widget-container">
            <p>Explore the World of Currencies with Our Finest Features &#8211; Unleashing Global Opportunities!</p>
          </div>
        </div>
        <div class="elementor-element elementor-element-213e0bba elementor-widget elementor-widget-image"
          data-id="213e0bba" data-element_type="widget" data-widget_type="image.default">
          <div class="elementor-widget-container">
            <img loading="lazy" decoding="async" width="1920" height="1080"
              src="/wp-content/uploads/2024/02/test-world-2.png" class="attachment-full size-full wp-image-693" alt=""
              srcset="/wp-content/uploads/2024/02/test-world-2.png 1920w, /wp-content/uploads/2024/02/test-world-2-300x169.png 300w, /wp-content/uploads/2024/02/test-world-2-1024x576.png 1024w, /wp-content/uploads/2024/02/test-world-2-768x432.png 768w, /wp-content/uploads/2024/02/test-world-2-1536x864.png 1536w"
              sizes="(max-width: 1920px) 100vw, 1920px" />
          </div>
        </div>
      </div>
    </div>

    <!-- Process Section -->
    <div class="elementor-element elementor-element-47171f06 e-flex e-con-boxed e-con e-parent" data-id="47171f06"
      data-element_type="container"
      data-settings="{&quot;background_background&quot;:&quot;gradient&quot;,&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}"
      data-core-v316-plus="true">
      <div class="e-con-inner">
        <div class="elementor-element elementor-element-61fe3439 e-con-full e-flex e-con e-child" data-id="61fe3439"
          data-element_type="container"
          data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
          <div
            class="elementor-element elementor-element-4d85bd2d elementor-widget__width-inherit elementor-widget elementor-widget-image"
            data-id="4d85bd2d" data-element_type="widget" data-widget_type="image.default">
            <div class="elementor-widget-container">
              <img loading="lazy" decoding="async" width="1080" height="1080"
                src="/wp-content/uploads/2024/02/orang.png" class="attachment-full size-full wp-image-694" alt=""
                srcset="/wp-content/uploads/2024/02/orang.png 1080w, /wp-content/uploads/2024/02/orang-300x300.png 300w, /wp-content/uploads/2024/02/orang-1024x1024.png 1024w, /wp-content/uploads/2024/02/orang-150x150.png 150w, /wp-content/uploads/2024/02/orang-768x768.png 768w"
                sizes="(max-width: 1080px) 100vw, 1080px" />
            </div>
          </div>
        </div>
        <div class="elementor-element elementor-element-7eeb1db4 e-con-full e-flex e-con e-child" data-id="7eeb1db4"
          data-element_type="container"
          data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
          <div class="elementor-element elementor-element-7f19929f e-flex e-con-boxed e-con e-child" data-id="7f19929f"
            data-element_type="container"
            data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
            <div class="e-con-inner">
              <div class="elementor-element elementor-element-30567ae4 elementor-widget elementor-widget-text-editor"
                data-id="30567ae4" data-element_type="widget" data-widget_type="text-editor.default">
                <div class="elementor-widget-container">
                  <p>Simplifying Your Entry into the Markets</p>
                </div>
              </div>
              <div class="elementor-element elementor-element-6c5a4cbb elementor-widget elementor-widget-heading"
                data-id="6c5a4cbb" data-element_type="widget" data-widget_type="heading.default">
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">Easy Step, Easy Earn.</h2>
                </div>
              </div>
            </div>
          </div>

          <!-- Process Steps -->
          <div class="elementor-element elementor-element-2a27d330 e-flex e-con-boxed e-con e-child" data-id="2a27d330"
            data-element_type="container"
            data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
            <div class="e-con-inner">
              <!-- Step 1: Choose -->
              <div class="elementor-element elementor-element-3db82777 e-con-full e-flex e-con e-child"
                data-id="3db82777" data-element_type="container"
                data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                <div
                  class="elementor-element elementor-element-cf334c0 elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon"
                  data-id="cf334c0" data-element_type="widget" data-widget_type="icon.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-icon-wrapper">
                      <div class="elementor-icon">
                        <svg width="40" height="40" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
                          <path
                            d="M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-1065ab5a elementor-widget elementor-widget-heading"
                  data-id="1065ab5a" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">1. Choose</h2>
                  </div>
                </div>
              </div>

              <!-- Step 2: Register -->
              <div class="elementor-element elementor-element-4fb23484 e-con-full e-flex e-con e-child"
                data-id="4fb23484" data-element_type="container"
                data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                <div
                  class="elementor-element elementor-element-51a89e0e elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon"
                  data-id="51a89e0e" data-element_type="widget" data-widget_type="icon.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-icon-wrapper">
                      <div class="elementor-icon">
                        <svg width="40" height="40" viewBox="0 0 576 512" fill="currentColor" aria-hidden="true">
                          <path
                            d="M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM528 400H303.2c.9-4.5.8-3.6.8-8 0-22.1-9.1-39.1-24-53.9-15-14.9-35.8-24.1-57.9-24.1s-42.9 9.2-57.9 24.1c-14.9 14.8-24 31.8-24 53.9 0 4.4-.1 3.5.8 8H48V144h480v256zM360 224c0 30.9-25.1 56-56 56s-56-25.1-56-56 25.1-56 56-56 56 25.1 56 56zM176 160c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm0 64c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm96-64c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-3957f5ca elementor-widget elementor-widget-heading"
                  data-id="3957f5ca" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">2. Register</h2>
                  </div>
                </div>
              </div>

              <!-- Step 3: Deposit -->
              <div class="elementor-element elementor-element-201a6ad8 e-con-full e-flex e-con e-child"
                data-id="201a6ad8" data-element_type="container"
                data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                <div
                  class="elementor-element elementor-element-b268d1d elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon"
                  data-id="b268d1d" data-element_type="widget" data-widget_type="icon.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-icon-wrapper">
                      <div class="elementor-icon">
                        <svg width="40" height="40" viewBox="0 0 640 512" fill="currentColor" aria-hidden="true">
                          <path
                            d="M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-1a647afd elementor-widget elementor-widget-heading"
                  data-id="1a647afd" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">3. Deposit</h2>
                  </div>
                </div>
              </div>

              <!-- Step 4: Trade -->
              <div class="elementor-element elementor-element-2cde3ae0 e-con-full e-flex e-con e-child"
                data-id="2cde3ae0" data-element_type="container"
                data-settings="{&quot;content_width&quot;:&quot;full&quot;,&quot;container_type&quot;:&quot;flex&quot;}">
                <div
                  class="elementor-element elementor-element-19f3c4e2 elementor-view-stacked elementor-shape-circle elementor-widget elementor-widget-icon"
                  data-id="19f3c4e2" data-element_type="widget" data-widget_type="icon.default">
                  <div class="elementor-widget-container">
                    <div class="elementor-icon-wrapper">
                      <div class="elementor-icon">
                        <svg width="40" height="40" viewBox="0 0 512 512" fill="currentColor" aria-hidden="true">
                          <path
                            d="M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="elementor-element elementor-element-34cefec4 elementor-widget elementor-widget-heading"
                  data-id="34cefec4" data-element_type="widget" data-widget_type="heading.default">
                  <div class="elementor-widget-container">
                    <h2 class="elementor-heading-title elementor-size-default">4. Trade</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- CTA Button -->
          <div class="elementor-element elementor-element-629c379a e-flex e-con-boxed e-con e-child" data-id="629c379a"
            data-element_type="container"
            data-settings="{&quot;container_type&quot;:&quot;flex&quot;,&quot;content_width&quot;:&quot;boxed&quot;}">
            <div class="e-con-inner">
              <div
                class="elementor-element elementor-element-733f734b elementor-align-justify elementor-widget elementor-widget-button"
                data-id="733f734b" data-element_type="widget" data-widget_type="button.default">
                <div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <router-link class="elementor-button elementor-button-link elementor-size-sm" to="/signup">
                      <span class="elementor-button-content-wrapper">
                        <span class="elementor-button-text">Create Account</span>
                      </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingWhyChooseUs'
}
</script>

<style>
/* Icon styles */
.elementor-view-stacked .elementor-icon {
  background-color: #aa8811;
  color: #fff;
  padding: 1rem;
  border-radius: 50%;
}

.elementor-shape-circle .elementor-icon {
  border-radius: 50%;
}

.elementor-icon {
  display: inline-block;
  line-height: 1;
  transition: all .3s;
}

.elementor-icon svg {
  width: 40px;
  height: 40px;
  position: relative;
  display: block;
}
</style>